/**
 * LocationIQ API key for reverse geocoding
 */
export const locationIQApiKey = '5bd2f65672ab1b';